import { BackgroundInfoType } from './enums/background-info-type';
import { Country } from './country';
import { Collapsible } from '../interfaces';

export class BackgroundInfoTemplate implements Collapsible {
  backgroundInfoTemplateRefId: number;
  description: string;
  objectType: BackgroundInfoType;
  taxYear: number;
  domicile?: Country;
  primaryFunction?: {
    primaryFunctionId: number,
    name: string
  };
  transactionType?: {
    transactionTypeId: number,
    name: string};
  name: string;
  collapsed: boolean;
}
